/**
 *
 * Edit Tableau
 *
 */

import React, { FC, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { actions } from 'containers/Setup/slice';

import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { Tableau } from './index';

export const EditTableau: FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { account } = useSelector(selectIntegrations);

  useEffect(() => {
    dispatch(actions.getAccount({ q: { uuid: id } }));
  }, [dispatch, id]);

  return (
    <Tableau
      action="Update"
      accountDetails={account.data}
      accountDetailsIsLoading={account.isLoading}
    />
  );
};
